import { Icon } from '@chakra-ui/icon';
import { Center } from '@chakra-ui/layout';
import { AlertTriangle } from 'react-feather';
import { colors } from '../../styles/theme/foundations/colors';

export const CriticalAlertIcon: React.FC = () => {
  return (
    <Center bg={colors.background.form.critical.light} borderRadius="100%" width="2.375rem" height="2.375rem">
      <Icon as={AlertTriangle} color={colors.text.critical.light} width="1.125rem" height="1.125rem" />
    </Center>
  );
};
